import { z } from "zod"
import { useCallback } from "react"
import { VatRateItem } from "@bundles/basket/models"
import { OwnWorkRequest } from "../WorkEditDialog"
import { useSchema } from "../schema"

export const useMapOwnWorkRequest = (hasFixedPrice: boolean, workNumberRequired: boolean, vatRateItems: VatRateItem[]) => {
    const schema = useSchema(hasFixedPrice, workNumberRequired)

    return useCallback(
        (data: z.infer<typeof schema>): OwnWorkRequest => {
            const addCustomWorkRequest: OwnWorkRequest = {
                category: data.category,
                description: data.description,
                selectedVatRate: vatRateItems.find((item) => item.vatRate.vatType === data.vatType)?.vatRate || vatRateItems[0].vatRate,
                workId: data.workNumber || "",
                customHourlyRate: data.hourlyRate,
                customRepairTimeListId: data.customRepairTimeListId,
                fixedPriceValue: data.fixedPriceValue,
                workTime: data.time,
            }

            return addCustomWorkRequest
        },
        [vatRateItems]
    )
}
